import { createAction } from '@reduxjs/toolkit'

import type {
  EditUserDataRequestPayload,
  EditUserDataSuccessPayload,
  EditUserSettingsRequestPayload,
  EditUserSettingsSuccessPayload,
  GetUserDataSuccessPayload
} from './types'

export const getUserDataRequest = createAction('GET_USER_DATA_REQUEST')
export const getUserDataSuccess = createAction<GetUserDataSuccessPayload>(
  'GET_USER_DATA_SUCCESS'
)
export const getUserDataFailed = createAction('GET_USER_DATA_FAILED')

export const editUserDataRequest = createAction<EditUserDataRequestPayload>(
  'EDIT_USER_DATA_REQUEST'
)
export const editUserDataSuccess = createAction<EditUserDataSuccessPayload>(
  'EDIT_USER_DATA_SUCCESS'
)
export const editUserDataFailed = createAction('EDIT_USER_DATA_FAILED')

export const editUserSettingsRequest =
  createAction<EditUserSettingsRequestPayload>('EDIT_USER_SETTINGS_REQUEST')
export const editUserSettingsSuccess =
  createAction<EditUserSettingsSuccessPayload>('EDIT_USER_SETTINGS_SUCCESS')
export const editUserSettingsFailed = createAction('EDIT_USER_SETTINGS_FAILED')
